import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    description: 'holdUntilModal.title',
    defaultMessage: 'Hold Until',
    id: '9ksnjo',
  },
  instructionText: {
    description: 'holdUntilModal.instruction',
    defaultMessage: 'Hold Until',
    id: 'i1rm86',
  },
  helperText: {
    description: 'holdUntilModal.helperText',
    defaultMessage:
      '{numberOfOrders, plural, one {Order} other {Orders}} will be placed On Hold until the selected date, after which {numberOfOrders, plural, one {it} other {they}} will be moved to Awaiting Shipment.',
    id: '96OIuc',
  },
  cancelButton: {
    description: 'holdUntilModal.cancel',
    defaultMessage: 'Cancel',
    id: 'Wlp8Vo',
  },
  holdButton: {
    description: 'holdUntilModal.holdOrder',
    defaultMessage: 'Hold',
    id: 'fyvTJO',
  },
});
